import { Injectable, inject } from '@angular/core';
import { ApiDataAccess, ApiResourceLocation, Dictionary } from '@softline/core';
import { SOFTLINE_API_GARAGE_SCAN } from '../garage.api';

@Injectable()
export class ScanRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  private createLocation(
    path: string,
    pathParams?: Dictionary<unknown>
  ): ApiResourceLocation {
    return pathParams ? { path, pathParams } : { path };
  }

  retrieve(type, barcode): Promise<any> {
    return this.#dataAccess.get(
      this.createLocation(SOFTLINE_API_GARAGE_SCAN, { type, barcode })
    );
  }
}
